import React, { useEffect} from 'react';
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import DirectionsRun from "@material-ui/icons/DirectionsRun";
//import EventNote from "@material-ui/icons/EventNote";
//import LiveHelp from "@material-ui/icons/LiveHelp";
//import Person from "@material-ui/icons/Person";
//import Settings from "@material-ui/icons/Settings";

// core components
import componentStyles from "assets/theme/components/dropdowns/user-dropdown.js";

const useStyles = makeStyles(componentStyles);

export default function UserDropdown() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const isMenuOpen = Boolean(anchorEl);
  const [firstName, setFirstName]=React.useState("")
  const [lastName, setLastName]=React.useState("")

  useEffect(() => {
    var token = localStorage.getItem("token")

    const fetchData = async () => {
      try {
        const res = await fetch('https://server.thelanofficial.com/get-name', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ token })
        });

        if (!res.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await res.json();
        if(data.valid === false){
          history.push("/auth/login")
        }else{
            setFirstName(data.firstname)
            setLastName(data.lastname)

          
        }
        
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchData();
  }, []);

  const LogoutClick = () =>{
  
    localStorage.removeItem("token")
    history.push("/auth/login")
  }


  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = "dropdowns-user-dropdown-id";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Typography
        variant="h6"
        component="h6"
        classes={{ root: classes.menuTitle }}
      >
        Welcome!
      </Typography>
      
      <Divider component="div" classes={{ root: classes.dividerRoot }} />
      <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleMenuClose}
      >
        <Box
          component={DirectionsRun}
          onClick={LogoutClick}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <Button onClick={LogoutClick}>
          Logout
        </Button>
       
      </Box>
    </Menu>
  );

  return (
    <>
      <Button
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        classes={{
          label: classes.buttonLabel,
          root: classes.buttonRoot,
        }}
      >
        <Avatar
          alt="..."
          src={require("assets/img/theme/user.png").default}
          classes={{
            root: classes.avatarRoot,
          }}
        />
        <Hidden mdDown>{firstName} {lastName}</Hidden>
      </Button>
      {renderMenu}
    </>
  );
}
